/**
 * Gutenberg column link
 * 
 */
export function columnLinkFront() {

  document.querySelectorAll('.wp-block-column[dataurl]').forEach(function (element) {
    element.style.cursor = 'pointer';
    let url = element.getAttribute('dataurl');
    let target = element.getAttribute('datatarget');

    element.addEventListener('click', function () {
      if (target !== '_blank') {
        window.location.href = url;
      } else {
        window.open(url, '_blank');
      }
    });
  });

}


/**
 * Browser & device detection
 * 
 */
export function browserDetection() {
  const ua = navigator.userAgent.toLowerCase();
  const html = document.documentElement;

  if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) {
    html.classList.add('safari');
  } else if (ua.indexOf('chrome') !== -1 && ua.indexOf('edg') === -1) {
    html.classList.add('chrome');
  } else if (ua.indexOf('firefox') !== -1) {
    html.classList.add('firefox');
  } else if (ua.indexOf('edg') !== -1) {
    html.classList.add('edge');
  }

  if (/mobile|android|iphone|ipad|ipod/i.test(ua)) {
    html.classList.add('mobile');
  } else {
    html.classList.add('desktop');
  }
};


/**
 * Load events
 * 
 */

export function checkLoadEvents() {

  document.fonts.ready
    .then(() => document.documentElement.classList.add('fonts-loaded'))
    .catch(err => console.warn('Font loading error:', err));


  document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.classList.add('dom-loaded');
  });

  window.addEventListener('beforeunload', () => {
    document.documentElement.classList.add('page-leave');
  });
}


/**
 * Aggiunge la classe body secondo lo scroll
 * 
 */
export function scrollBody(lenis = null) {

  let lastScrollY = window.scrollY;
  const scrollDelta = 10; // Margine di tolleranza per il cambiamento di scroll

  document.body.classList.toggle("top-page", window.scrollY < 100);
  document.body.classList.toggle("scrolled", window.scrollY >= 100);

  const updateScrollState = () => {
    const currentScrollY = window.scrollY;
    const deltaY = Math.abs(currentScrollY - lastScrollY);

    if (deltaY >= scrollDelta || (lastScrollY >= 100 && currentScrollY < 100) || (lastScrollY < 100 && currentScrollY >= 100)) {
      document.body.classList.toggle("scroll-down", currentScrollY > lastScrollY);
      document.body.classList.toggle("top-page", currentScrollY < 100);
      document.body.classList.toggle("scrolled", currentScrollY >= 100);
      lastScrollY = currentScrollY;
    }
  };

  if (lenis) {
    lenis.on('scroll', updateScrollState);
  } else {
    let ticking = false;
    window.addEventListener("scroll", () => {
      if (!ticking) {
        requestAnimationFrame(updateScrollState);
        ticking = true;
      }
    });
  }

}